import React, { PropTypes } from 'react';
import InfiniteList from './InfiniteList';
import { List } from 'immutable';
import { SortDirection } from 'react-virtualized';
import ImmutablePropTypes from 'react-immutable-proptypes';

const setDirection = (currentSort, sort) => {
  let sortDirection;
  if (currentSort.sortBy !== sort.sortBy) {
    sortDirection = SortDirection.ASC;
  } else {
    // Invert it
    switch (sort.sortDirection) {
      case SortDirection.DESC:
        sortDirection = SortDirection.ASC;
        break;
      default:
        sortDirection = SortDirection.DESC;
        break;
    }
  }

  return {
    ...sort,
    sortDirection,
  };
};

const sortClassName = (sort, field) => {
  if (sort.sortBy === field) {
    switch (sort.sortDirection) {
      case SortDirection.DESC:
        return 'arrow up';
      case SortDirection.ASC:
        return 'arrow down';
      default:
        return null;
    }
  }

  return null;
};

export default class AsyncInfiniteList extends React.Component {
  static propTypes = {
    initialData: ImmutablePropTypes.list.isRequired,
    totalCount: PropTypes.number.isRequired,
    loadNext: PropTypes.func.isRequired, // the loading promise
    renderColumns: PropTypes.func.isRequired,
    onRowClick: PropTypes.func,
    onItemsLoaded: PropTypes.func,
    customerRowRenderer: PropTypes.func,
  };

  constructor(props) {
    super(props);

    this.state = {
      isNextPageLoading: false,
      hasNextPage: true,
      currentSort: {},
      currentList: props.initialData,
    };

    this.loadNextPage = this.loadNextPage.bind(this);
    this.verifyNextPage = this.verifyNextPage.bind(this);
    this.sortPage = this.sortPage.bind(this);
  }

  componentWillMount() {
    this.verifyNextPage();
  }

  verifyNextPage() {
    const { totalCount } = this.props;
    const { currentList } = this.state;

    this.setState({
      hasNextPage: totalCount > currentList.size,
    });
  }

  loadNextPage({ startIndex, stopIndex }) {
    const { totalCount, onItemsLoaded } = this.props;
    const { isNextPageLoading, currentList, currentSort } = this.state;

    if (isNextPageLoading) return;

    if (stopIndex < totalCount) {
      this.setState({
        isNextPageLoading: true,
      });

      // Loading async
      this._fetchNext(startIndex, stopIndex, currentSort)
        .then(result => {
          const newList = currentList.concat(result.entities);

          this.setState({
            currentList: newList,
          });

          return newList;
        })
        .then(items => {
          if (onItemsLoaded) onItemsLoaded(items, totalCount);
        });
    } else {
      this.setState({
        isNextPageLoading: false,
      });
    }
  }

  sortPage(sort) {
    const { isNextPageLoading, currentSort } = this.state;

    if (isNextPageLoading) return;

    this.setState({
      isNextPageLoading: true,
    });

    const newSort = setDirection(currentSort, sort);

    this._fetchNext(0, 40, newSort).then(result => {
      this.setState({
        currentSort: newSort,
        currentList: List(result.entities),
      });
      this.verifyNextPage();
    });
  }

  _fetchNext(start, stop, sort = {}) {
    return this.props.loadNext(start, stop, sort).then(result => {
      this.verifyNextPage();

      // Page is not loading anymore
      this.setState({
        isNextPageLoading: false,
      });

      return result;
    });
  }

  render() {
    const {
      renderColumns,
      onRowClick,
      customerRowRenderer,
      ...rest
    } = this.props;
    const {
      isNextPageLoading,
      hasNextPage,
      currentList,
      currentSort,
    } = this.state;

    const renderWithSort = width => {
      const columns = renderColumns(width);
      return columns.map(c => {
        // Do not apply sort on checkbox columns
        if (c.key === 'selected') return c;

        return React.cloneElement(c, {
          headerClassName: sortClassName(currentSort, c.key),
        });
      });
    };

    return (
      <InfiniteList
        hasNextPage={hasNextPage}
        isLoading={isNextPageLoading}
        list={currentList}
        loadNextPage={this.loadNextPage}
        sortDirection={currentSort.sortDirection}
        sortPage={this.sortPage}
        renderColumns={renderWithSort}
        onRowClick={onRowClick}
        customerRowRenderer={customerRowRenderer}
        {...rest}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/common/components/AsyncInfiniteList.js